"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmAgbs = void 0;
const react_native_1 = require("react-native");
const react_1 = __importStar(require("react"));
const ConfirmAgbs_style_1 = require("./ConfirmAgbs.style");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const atome_1 = require("../../atome");
const organisms_1 = require("../../organisms");
const molecules_1 = require("../../molecules");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
// @ts-ignore
function ConfirmAgbs({ navigation }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [agbs, setAgbs] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', () => {
            setTimeout(() => {
                if (!auth.isAuthenticated) {
                    navigation.navigate('Login');
                    return;
                }
                if (auth.isTermsAgree) {
                    if (auth.isPrivacyPolicyAgree) {
                        navigation.navigate('Dashboard');
                    }
                    if (!auth.isPrivacyPolicyAgree) {
                        navigation.navigate('ConfirmPrivacyPolicy');
                    }
                    return;
                }
                setLoading(false);
            }, 500);
        });
    }, [auth, navigation]);
    const confirmAgbs = async () => {
        const res = await User_service_1.default.confirmAgbs();
        if (res.error) {
            console.log(res);
            return;
        }
        const newAuth = { ...auth };
        newAuth.isTermsAgree = true;
        dispatch((0, reducers_1.setAuth)(newAuth));
        await async_storage_1.default.setItem('TermsAgree', 'true');
        if (!auth.isPrivacyPolicyAgree) {
            navigation.navigate('ConfirmPrivacyPolicy');
            return;
        }
        navigation.navigate('Dashboard');
    };
    return (loading
        ? react_1.default.createElement(atome_1.Loading, null)
        : react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white' } },
            react_1.default.createElement(react_native_1.ScrollView, { style: ConfirmAgbs_style_1.styles.scrollView },
                react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: ConfirmAgbs_style_1.styles.container },
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.marginVertical35,
                            GlobalStyles_1.globalStyles.marginHorizontal15,
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [ConfirmAgbs_style_1.styles.heading3] }, "AGB BEST\u00C4TIGEN"),
                        react_1.default.createElement(atome_1.Text, null, "Zum 22. April 2022 haben Sich unsere Allgemeinen Gesch\u00E4ftsbedingungen ge\u00E4ndert. Bevor Sie fortfahren k\u00F6nnen, m\u00FCssen Sie den AGBs zustimmen."),
                        react_1.default.createElement(react_native_1.View, { style: [ConfirmAgbs_style_1.styles.row, ConfirmAgbs_style_1.styles.marginRow, ConfirmAgbs_style_1.styles.alignCenter] },
                            react_1.default.createElement(molecules_1.Checkbox, { checked: agbs, label: "", onPress: () => setAgbs(!agbs) }),
                            react_1.default.createElement(atome_1.Label, { style: [ConfirmAgbs_style_1.styles.marginBottom15] },
                                "Ich stimme den",
                                ' ',
                                react_1.default.createElement(atome_1.Link, { underlined: true, href: "https://www.nowomed.com/agb" }, "allgemeinen Gesch\u00E4ftsbedingungen"),
                                ' ',
                                "zu.")),
                        react_1.default.createElement(react_native_1.View, { style: [ConfirmAgbs_style_1.styles.row, ConfirmAgbs_style_1.styles.marginRow, ConfirmAgbs_style_1.styles.buttonContainer] },
                            react_1.default.createElement(react_native_1.Pressable, { style: [ConfirmAgbs_style_1.styles.button, !agbs && ConfirmAgbs_style_1.styles.disabledButton], onPress: confirmAgbs, disabled: !agbs },
                                react_1.default.createElement(atome_1.Text, { style: [ConfirmAgbs_style_1.styles.buttonText] }, "WEITER"))))))));
}
exports.ConfirmAgbs = ConfirmAgbs;
